import { Component, Input, OnChanges } from '@angular/core';

/** Ring that fills as a long task runs. Ink on a quiet track unless a colour is passed. */
@Component({
  selector: 'progress-circle',
  standalone: true,
  imports: [],
  templateUrl: './progress-circle.component.html',
  styleUrl: './progress-circle.component.css',
})
export class ProgressCircleComponent implements OnChanges {
  @Input() size: number = 100; // Controls the size of the component
  /** Stroke colour; empty uses the console ink (--bk-fill). */
  @Input() color: string = '';
  @Input() progress: number = 0; // Controls the progress made
  /** Accessible name of the bar, e.g. "Import progress". */
  @Input() label: string = 'Progress';

  circumference: number = 2 * Math.PI * 16; // 2πr, where r = 16
  progressOffset: number = this.circumference;
  clamped = 0;

  ngOnChanges(): void {
    // Clamp the progress between 0 and 100 and calculate the offset
    this.clamped = Math.round(Math.min(Math.max(Number(this.progress) || 0, 0), 100));
    this.progressOffset = this.circumference * (1 - this.clamped / 100);
  }
}
